const content = 
`
<p>
  本协议由您（以下或称“卖家”）与图灵深视（北京）科技有限公司（以下简称“图灵云仓App/微信小程序”或“平台”）共同缔结。
</p>
<p style="text-decoration: underline;font-weight: bold">
  您在接受本协议之前，请您仔细阅读全部条款内容，特别是免除或限制责任的条款、法律适用和争议解决条款等用粗体标识的条款，您需要重点阅读。如您点击同意接受本协议即视为您同意受本协议约束入驻平台。如您对本协议的条款有疑问，请通过平台的客服进行咨询，客服将向您解释条款内容。如您不同意本协议内容，请不要进行后续操作。如您继续操作，视为您同意本协议。本协议自您同意之日起生效。平台中的用户协议、费用或交易规则、隐私政策等相关约束卖家权利义务的条款和本协议具有同等法律效力。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    &nbsp;
  </strong>
  本协议的订立、履行、效力、解释及争议的解决均适用《中华人民共和国合同法》及中华人民共和国其它法律法规。因订立或执行本协议而产生的任何争议，协议双方应首先通过协商解决。若协商不能解决，应提交本协议签订地即北京市海淀区人民法院诉讼。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  <strong>
    &nbsp;
  </strong>
  一、发布商品要求
</p>
<p>
  1、您使用图灵云仓App/微信小程序进行商品出售，须持续满足以下条件:
</p>
<p>
  （1）能独立承担本协议法律责任。如卖家不满18周岁，则承诺签署时已获得法定监护人的同意或由其法定监护人代为同意，如卖家无法独立承担本协议法律责任的，其相应的法律责任由其法定监护人承担。
</p>
<p>
  （2）完成个人手机及身份验证；
</p>
<p>
  （3）同意并接受本协议及图灵云仓App/微信小程序规则；
</p>
<p>
  （4）转让或出售的商品来源合法，符合相关法律法规规定且不侵犯任何第三方合法权益。
</p>
<p>
  2、上传信息通过平台审核后，完成商品发布；平台不定期人工审核用户上传商品的信息，不合规将被立即下架。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    3
  </strong>
  、平台向卖家提供出售商品的网络经营场所和服务，卖家上架商品时需缴纳相应的费用作为平台服务费（具体见页面详情）。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  二、卖家权利及义务
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    1
  </strong>
  、您完成注册、上传商品时足额缴纳相应的费用后，有权在平台出售商品。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    &nbsp;2
  </strong>
  、您应妥善保管登录图灵云仓
  <strong>
    App/
  </strong>
  微信小程序的账号、密码等保密信息，当发生信息泄露或密码遗失时，您应立即向平台客服申请挂失。您登录账号后在平台中的一切操作均应符合国家法律法规、规章政策和法令的规定，还应符合本协议条款和相关规则的规定，上述您账户下的操作视为您的行为，由您承担全部责任。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    3
  </strong>
  、您应当向平台提供真实、合法、准确、有效的注册资料以及退货信息，并保证提供的提供的内容的有效性及安全性，平台可以通过您预留的联系方式与您进行联系。同时，您也有义务在相关资料或信息实际变更时，及时更新有关资料或及时通知平台。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    4
  </strong>
  、您确保出售的商品属于合法来源，您有权出售，且不损害任何第三方合法权益，否则您将承担相应的法律及赔偿责任。您应当留存商品相关合法来源凭证（如为境外商品，应确保商品通过正规渠道方式入境并缴纳相应税费），当平台或者相关政府部门要求提供时，您应当配合提供。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    5
  </strong>
  、您应当按照订单要求的商品、数量和时间及时、准确地向买家发货。您因错发、漏发货产生的相关费用由您自行承担。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    6
  </strong>
  、您在使用服务进行交易的过程中应当遵守诚实守信的原则，不在交易过程中采取不正当竞争行为，不扰乱网上交易的正常秩序，不盗用他人图片展示，不从事与网上交易无关的行为，包括但不限于利用平台漏洞恶意刷单、套现的行为。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    &nbsp;7
  </strong>
  、您不得隐瞒任何可能对平台产生风险的事项，包括但不限于商品出现缺陷、瑕疵、权利纠纷、重大违约、上传资料包含病毒木马等，若发生此类影响平台商誉、正常转让、安全的事项的，平台有权解除本协议并追究相应责任。
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    8
  </strong>
  、您承诺，不会采取任何手段或措施，包括但不限于明示或暗示买家或通过其他方式转移其可以通过平台出售的商品，或达成交易后不经由平台接入的支付方式收取交易金额，以规避向平台支付相关服务费用。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  三、平台权利及义务
</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    &nbsp;1
  </strong>
  、因网上交易平台的特殊性，图灵云仓
  <strong>
    App/
  </strong>
  微信小程序以行业通用标准对相关内容进行判别，判断认为这些内容或行为具有违法或不当性质的，发现注册数据或交易行为中存在任何问题或怀疑，均有权向您询问或要求改正的通知，并根据不同情况对您采取限制性措施或停止对您提供服务，您同意由于排版错误或信息错误导致商品以不正确或明显不合理的价格或信息显示的，平台有权取消该等不正确或明显不合理价格或信息的商品订单的权利，并保留就您的行为给平台及买家或其他权利人造成的损失进行追偿的权利。
</p>
<p>
  2、您同意在因为商品交易导致您和买家或您和第三方发生纠纷时，如有必要，授权平台向相对人及或政府相关部门披露您的个人卖家信息及相关订单信息。
</p>
<p>
  3、如您违反卖家义务及平台规则的，平台有权采取包括但不限于暂停部分或全部服务、关闭交易订单、封号、禁售、冻结资金等措施，并保留采取进一步法律措施的权利。
</p>
<p>
  4、平台有权收取相关费用，也可能根据业务调整而变更向您提供服务的主体，变更后的主体履行本协议项下义务向您提供服务，前述变更不会影响您在本协议项下权益。发生争议时，您可根据具体使用的服务及对您权益产生影响的对象确认争议主体。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  四、定价及发货要求
</p>
<p>
  1、商品定价
</p>
<p>
  平台采取的是由卖家出价的电商平台交易模式，<span style="text-decoration: underline;font-weight: bold">卖家可以自主定价。</span>
</p>
<p>
  2、发货时效
</p>
<p>
  （1）卖家应在<span style="text-decoration: underline;font-weight: bold">【买家付款后的48小时内】</span>
  </strong>
 完成发货，<span style="text-decoration: underline;font-weight: bold">自行预约顺丰快递</span>，并于发货后在平台上传快递单号。
 <span style="text-decoration: underline;font-weight: bold">
 如果卖家上传的发货信息在24小时未生成揽收记录的，均视为虚假发货。但顺丰出具书面证明揽收失误的除外。
 </span>
</p>
<p>
  （2）卖家发货必须使用顺丰快递向平台寄件，并加固商品外包装。如出现使用非指定快递、包装盒破损、运单号无法匹配订单号等情形的快递商品，平台有权进行拒收，如因此造成取消订单、无法退货及相应后果的，平台不承担责任；
  <span style="text-decoration: underline;font-weight: bold">
  因快递原因造成的破损、毁损或遗失，用户可与快递协商解决，平台不承担责任，请谨慎选择是否自费保价服务。
  </span>

</p>
<p>
  3、&nbsp;订单生成后，
  <span style="text-decoration: underline;font-weight: bold">卖家逾期发货订单将自动取消。
  </span>
 
</p>
<p>
  <strong>
    4
  </strong>
  、<span style="text-decoration: underline;font-weight: bold">因商品价值较高，平台仅接受顺丰提供的快递服务。卖家应使用顺丰快递妥善包装寄付至平台，破损件或非顺丰件平台拒绝签收。
  因快递原因造成的商品破损，损毁或遗失，用户可与快递协商解决，平台不承担责任。
  </span>
 
</p>
<p style="font-weight: bold">
  五、平台服务费和支付手续费的缴纳及归还
</p>
<p>
  1、平台在卖家上架商品时向卖家收取 
  <span style="text-decoration: underline;font-weight: bold">相应的费用作为平台服务费（具体见页面详情）。
  </span>
 
  
</p>
<p>
  2、卖家如不足额缴纳相应费用的，将无法上架出售商品。商品经过平台查验鉴别、质检通过后，在卖家无违法或违反平台规则的前提下，非卖家原因导致交易失败则服务费全额退回。
</p>
<p>
  <strong>
    3
  </strong>
  、
  <span style="text-decoration: underline;font-weight: bold">
  您若有以下情况之一的，平台有权全额扣除服务费，且保留停止向您提供服务的权利：
  </span>

</p>
<p>
  （
  <strong>
    1
  </strong>
  ）
  <span style="text-decoration: underline;font-weight: bold">
如您违反法律、法规、政策及本协议、平台规则或违反其对买家的承诺致买家或者平台受损的，平台有完全的权利进行责任判定，且基于前述判定直接使用保证金代您向买家退还货款、划扣约定的违约金及或赔偿款；
  </span>
</p>
<p>
  （
  <strong>
    2
  </strong>
  ）
    <span style="text-decoration: underline;font-weight: bold">
  如您在交易过程中未按照发货时效发货或虚假发货的，或者寄出的商品不符合买家选择的款式、尺码、成色等要求的，商品缺少配件的，引导买家线下交易或通过第三方平台完成交易的；
  </span>

</p>
<p>
  （
  <strong>
    3
  </strong>
  ）
<span style="text-decoration: underline;font-weight: bold">
  如您提供的商品出现在平台鉴别及查验质检不通过的情形；
  </span>

</p>
<p>
  （
  <strong>
    4
  </strong>
  ）
  <strong>
    &nbsp;
  </strong>
  

  <span style="text-decoration: underline;font-weight: bold">
  如您违反本协议及平台规则或者存在其他违法、侵害平台合法权益的行为的，没有在买家或平台要求的合理期限内改正或无法改正的。
  </span>

</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  六、平台收费
</p>
<p>
  1、如果买卖双方交易达成，平台向卖家收取
  <span style="text-decoration: underline;font-weight: bold">
  相应的费用作为平台服务费（具体见页面详情）。
  </span>

</p>
<p>
  2、平台将在买家确认收货后与您进行结算。如因卖家收款账户银行系统更新升级问题、不可抗力等，结算时间顺延。
</p>
<p>
  3、
  <span style="text-decoration: underline;font-weight: bold">
  商品寄到平台的邮费由卖家自行承担。
  </span>
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  七、商品查验及退回
</p>
<p>
  1、请卖家在将商品寄送至平台查验前，应仔细核验自身商品情况，
  
  <span style="text-decoration: underline;font-weight: bold">
平台将对卖家商品依据下述查验标准进行查验：
  </span>
</p>
<p>
  （1）商品是否存在明显与卖家描述不符的污渍、划痕、染色、破损、磨损等质量问题；
</p>
<p>
  （2）商品是否存在实物名称、款号、色号、尺码等与订单信息不符的情形；
</p>
<p>
  （3）商品是否存在与外盒（外包装）、配件不配套的情形；
</p>
<p>
  （4）商品是否存在缺少配件的情形，包括但不限于身份卡、肩带等；
</p>
<p>
  （5）商品是否存在与卖家描述不符的外包装破损、严重折痕及撕裂等情形；
</p>
<p>
  （6）商品是否存在明显与卖家描述不符的使用痕迹；
</p>
<p>
  （7）商品是否由平台鉴别是假冒商品；
</p>
<p>
  （8）商品是否存在其他影响商品外观完好的情形；
</p>
<p>
  （9）商品是否存在商品翻新，未告知或未完全告知的情况。
  <span style="text-decoration: underline;font-weight: bold">
  为确保商品的品质，平台会对商品拆封鉴别质检，通过后的商品会统一包装发货。
  </span>

</p>
<p style="text-decoration: underline;font-weight: bold">
  <strong>
    2
  </strong>
  、如果您提供的商品出现在平台鉴别及查验质检不通过的情形
  <strong>
    &nbsp;
  </strong>
  ，平台将向您到付退货并在扣除服务费及垫付费用（如有）后退还剩余款项。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  八、协议终止
</p>
<p>
  1、&nbsp;您应理解，您应按照本协议约定使用平台提供的服务，如您严重违反本协议、平台各类规则以及其他法律法规的，平台有权停止部分或全部服务，或者有权终止协议。
</p>
`

export default {
  content,
  title: '图灵云仓卖家协议'
}